// crypto.randomUUID() is SECURE-CONTEXT ONLY — it exists on https:// and on
// localhost, and is undefined over plain http:// to a LAN IP. Trim Log is
// opened from phones at http://<box-ip>:8990, where calling it throws
// "crypto.randomUUID is not a function" and kills signup, run saves, sync and
// photo ids. crypto.getRandomValues() is NOT secure-context gated, so the
// fallback below is still cryptographically random — just assembled into the
// RFC 4122 v4 layout by hand.
//
// Every UUID in the client goes through here. Do not call crypto.randomUUID()
// directly.
export function uuid(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();

  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6]! & 0x0f) | 0x40; // version 4
  b[8] = (b[8]! & 0x3f) | 0x80; // variant 10xx
  const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
